import React from 'react';
import { Image } from 'react-bootstrap';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/AddProfileModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/alert.svg';
import RespModal from './RespModal';

function GenericModalError(props) {
    return(
        <RespModal hasOpen={props.hasOpen}>
        <div className="modalsizeaddprofile" >
            <Image src={success} /><br /><br />
            <div id="modalcontainsuccessaddprofile">
                 {props.children}
            </div>
            <div class="cancelresploginbuttonouter">
        <Button
                id="cancelresploginbuttoaddprofile"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >OK
        </Button>
            </div>
        </div>  
    </RespModal>
    );
}
export default GenericModalError;
